"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isObject_1 = __importDefault(require("lodash/isObject"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_keyboard_aware_scroll_view_1 = require("react-native-keyboard-aware-scroll-view");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/login/slice");
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const messages_1 = require("../../../constants/messages");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("./components");
const styles_1 = __importDefault(require("./styles"));
const TextInputField = ({ containerStyle, errorMessage, isRequired = false, label, style, ...props }) => {
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    return (react_1.default.createElement(react_native_1.View, { style: [containerStyle] },
        label && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { alignItems: 'center' }] },
            react_1.default.createElement(CustomText_1.default, { style: [styles_1.default.inputLabel, { marginTop: 0 }] }, label),
            isRequired && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.inputRequireView },
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.inputRequireLabel }, "\u5FC5\u9808"))))),
        react_1.default.createElement(react_native_1.TextInput, { style: [
                styles_1.default.textInput,
                !!errorMessage && { borderColor: '#F80F63', backgroundColor: '#FDF3F3' },
                isFocused && { borderColor: '#00AEEF', backgroundColor: '#FEFEFE' },
                style
            ], placeholderTextColor: "#C8C8C8", onFocus: handleFocus, onBlur: handleBlur, ...props }),
        !!errorMessage && (react_1.default.createElement(CustomText_1.default, { style: styles_1.default.errorMessage },
            " ",
            errorMessage,
            " "))));
};
const MyProfileScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [nicknameMessage, setNicknameErrorMessage] = (0, react_1.useState)('');
    const [biographyMessage, setBiographyErrorMessage] = (0, react_1.useState)('');
    const [isExistMyProfile, setExistMyProfile] = (0, react_1.useState)(!!myProfile?.user_id);
    const refFormValue = (0, react_1.useRef)({
        backgroundSource: myProfile?.header_url || '',
        avatarSource: myProfile?.thumbnail_url || '',
        nickname: myProfile?.nickname || '',
        biography: myProfile?.biography ||
            `✅投資歴：\n✅投資スタイル：\n✅現在の資産額：\n✅目標利回り：\n✅投資に対する哲学：\n✅好きな人物や書籍：\n✅達成したい目標：`,
        location: myProfile?.location || '',
        introduceVideo: myProfile?.video_url || '',
    });
    (0, react_1.useLayoutEffect)(() => {
        if (!isExistMyProfile && myProfile?.user_id) {
            refFormValue.current = {
                backgroundSource: myProfile?.header_url || '',
                avatarSource: myProfile?.thumbnail_url || '',
                nickname: myProfile?.nickname || '',
                biography: myProfile?.biography || '',
                location: myProfile?.location || '',
                introduceVideo: myProfile?.video_url || '',
            };
            setExistMyProfile(true);
        }
    }, [myProfile]);
    const handleApplyChange = async () => {
        refFormValue.current.nickname = refFormValue.current.nickname.trim();
        refFormValue.current.biography = refFormValue.current.biography.trim();
        refFormValue.current.location = refFormValue.current.location.trim();
        if (!refFormValue.current.nickname) {
            return setNicknameErrorMessage('ユーザー名は必須項目です。');
        }
        if (JSON.stringify(refFormValue.current.biography)?.length > 1000) {
            return setBiographyErrorMessage('自己紹介は約1000文字以内で入力してください。');
        }
        const form = new FormData();
        form.append('nickname', refFormValue.current.nickname);
        form.append('biography', refFormValue.current.biography);
        form.append('location', refFormValue.current.location);
        if (!!refFormValue.current.backgroundSource &&
            refFormValue.current.backgroundSource != myProfile?.header_url) {
            const file = await (0, helpler_1.convertImageUrlToFile)(refFormValue.current.backgroundSource);
            if (file) {
                form.append('header', file);
            }
        }
        else if (!refFormValue.current.backgroundSource &&
            refFormValue.current.backgroundSource != myProfile?.header_url) {
            form.append('is_deleting_header', '1');
        }
        if (!!refFormValue.current.avatarSource &&
            refFormValue.current.avatarSource != myProfile?.thumbnail_url) {
            const file = await (0, helpler_1.convertImageUrlToFile)(refFormValue.current.avatarSource);
            if (file) {
                form.append('image', file);
            }
        }
        if (!!refFormValue.current.introduceVideo &&
            refFormValue.current.introduceVideo != myProfile?.video_url) {
            const file = await (0, helpler_1.convertImageUrlToFile)(refFormValue.current.introduceVideo);
            if (file) {
                form.append('video', file);
            }
        }
        if (!refFormValue.current.introduceVideo && !!myProfile?.video_url) {
            form.append('is_deleting_video', '1');
        }
        setNicknameErrorMessage('');
        setLoading(true);
        User_1.default.updateProfile(form)
            .then(() => {
            dispatch((0, slice_2.updateNicknameAction)(refFormValue.current.nickname));
            dispatch(slice_1.default.actions.showToast('プロフィール情報を更新しました'));
            (0, rootNavigation_1.goBack)();
        })
            .catch((err) => {
            let message = messages_1.MESSAGES.ERROR_MESSAGE_DEFAULT;
            dispatch(slice_1.default.actions.setToastType(false));
            if (err.code === 'ECONNABORTED') {
                message = '設定されたタイムアウト時間を超過したため、処理を中止しました';
            }
            else if (err?.response?.data?.error?.message) {
                if ((0, isObject_1.default)(err?.response?.data?.error?.message)) {
                    const keys = Object.keys(err?.response?.data?.error?.message);
                    message = keys.map((key) => err?.response?.data?.error?.message[key][0]);
                }
            }
            dispatch(slice_1.default.actions.showToast(message));
        })
            .finally(() => {
            setLoading(false);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    if (!isExistMyProfile)
        return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'プロフィール編集', styleContainer: {
                    backgroundColor: 'white',
                    marginBottom: 0,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerLabel }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), rightIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerLabel }, "\u4FDD\u5B58"), onLeftPress: rootNavigation_1.goBack, onRightPress: handleApplyChange }),
            react_1.default.createElement(LoadingLogin_1.default, null)));
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'プロフィール編集', styleContainer: {
                backgroundColor: 'white',
                marginBottom: 0,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerLabel }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), rightIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerLabel }, "\u4FDD\u5B58"), onLeftPress: rootNavigation_1.goBack, onRightPress: handleApplyChange }),
        react_1.default.createElement(react_native_keyboard_aware_scroll_view_1.KeyboardAwareScrollView, { style: styles_1.default.body, contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(20),
            }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(components_2.BackgroundEditor, { defaultSource: refFormValue.current.backgroundSource, onChange: (source) => (refFormValue.current.backgroundSource = source) }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                react_1.default.createElement(components_2.AvatarEditor, { defaultSource: refFormValue.current.avatarSource, onChange: (source) => (refFormValue.current.avatarSource = source) }),
                react_1.default.createElement(TextInputField, { isRequired: true, label: "\u30E6\u30FC\u30B6\u30FC\u540D", maxLength: 50, defaultValue: refFormValue.current.nickname, containerStyle: { marginTop: (0, scale_1.scale)(12) }, placeholder: "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B", onChangeText: (text) => (refFormValue.current.nickname = text), errorMessage: nicknameMessage }),
                react_1.default.createElement(TextInputField, { label: "\u81EA\u5DF1\u7D39\u4ECB", multiline: true, maxLength: 1000, defaultValue: refFormValue.current.biography, containerStyle: { marginTop: (0, scale_1.scale)(20) }, style: { height: (0, scale_1.scale)(155), lineHeight: (0, scale_1.moderateScale)(22.5) }, placeholder: "\u81EA\u5DF1\u7D39\u4ECB\u3092\u5165\u529B", onChangeText: (text) => {
                        refFormValue.current.biography = text;
                        setBiographyErrorMessage('');
                    }, errorMessage: biographyMessage }),
                react_1.default.createElement(TextInputField, { label: "\u5834\u6240", maxLength: 191, defaultValue: refFormValue.current.location, containerStyle: { marginTop: (0, scale_1.scale)(20) }, placeholder: "\u5834\u6240\u3092\u5165\u529B", onChangeText: (text) => (refFormValue.current.location = text) }),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.inputLabel }, "\u81EA\u5DF1\u7D39\u4ECB\u52D5\u753B"),
                react_1.default.createElement(components_2.IntroduceVideoEditor, { defaultSource: refFormValue.current.introduceVideo, onChange: (source) => (refFormValue.current.introduceVideo = source) }),
                react_1.default.createElement(CustomText_1.default, { style: [styles_1.default.introduceVideoNote, { marginTop: (0, scale_1.scale)(8) }] }, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u308B\u30D5\u30A1\u30A4\u30EB\u62E1\u5F35\u5B50\uFF1AMP4, MOV"),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.introduceVideoNote }, "\u6700\u5927\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30B5\u30A4\u30BA\uFF1A512MB"))),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = MyProfileScreen;
